import { PageLoader } from '@customerio/pluma-components/react';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { RumPageRendered } from '@/services/rum/use-page-rendered';

// The email composer's iframe editor (Journeys). Lazy, so the editor (and the page module, which marks the page
// as embedded when it loads) stays out of every other chunk.
const EmailEmbedPage = lazy(() => import('@/pages/workspaces/design-studio/embed/cio/email/embed-route.page'));

function EmailEmbedRoute() {
  return (
    <Suspense fallback={<PageLoader />}>
      <RumPageRendered>
        <EmailEmbedPage />
      </RumPageRendered>
    </Suspense>
  );
}

export const Route = createFileRoute('/design-studio-embed/cio/email')({
  component: EmailEmbedRoute,
});
